<template>
  <ul class="con-s">
     <vs-td class="whitespace-no-wrap">
         <vs-switch color="success" v-model="switch1"/>
      </vs-td>
  </ul>
</template>

<script>
export default {
 
}
</script>
